import { isIos, isSubsOffer } from "@/utils/lodash";
import store from "@/vuex/store";
import { basePlatform, baseUrl } from "@/config/env.js";
/**
 * 判断是否安装了App
 * @param {*} schemeUrl
 */
export const jumpToSuperpay = async schemeUrl => {
  try {
    // if (isIos()) {
    //   window.location = schemeUrl;
    // } else {
    //   window.open(schemeUrl);
    // }

    window.location = schemeUrl;
  } catch (error) {
    return new Promise.reject(error);
  }
};

/**
 * 拼接URL
 * @param {*} postOfferData
 * @param {*} offer
 */
export const joinSuperPayUrl = (postOfferData, offer, schemeUrl) => {
  const dataMap = new Map();
  let jionUrl = schemeUrl + "?";

  const sp_identifier = JSON.stringify(postOfferData); //post offer接力棒
  const price = offer.iap.price;
  const order_finish_url = `${location.origin}/paymentResult`;
  const order_fail_url = `${location.origin}/paymentResult`;
  const order_auto_buy = 1;
  const order_style = 2;
  const order_show_try_for_free = 0; //是否显示try for free //TODO
  const order_information = ""; //商品的描述
  const order_web_url = location.origin + "?a=1";
  const order_post_url = baseUrl + "/web/v1/order/iap"; //post offer的URL
  const order_current_url = location.href; //取消后返回的页面

  dataMap.set("sp_identifier", sp_identifier);
  dataMap.set("price", price);
  dataMap.set("order_finish_url", order_finish_url);
  dataMap.set("order_fail_url", order_fail_url);
  dataMap.set("order_auto_buy", order_auto_buy);
  dataMap.set("order_style", order_style);
  dataMap.set("order_show_try_for_free", order_show_try_for_free);
  dataMap.set("order_information", order_information);

  dataMap.set("order_web_url", order_web_url);
  dataMap.set("order_post_url", order_post_url);
  dataMap.set("order_current_url", order_current_url);

  if (isSubsOffer(offer)) {
    //如果是订阅类型的offer：
    const { subscription } = offer;
    dataMap.set("period_type", subscription.period_type);
    dataMap.set("period", subscription.period);
  }

  if (offer.hasOwnProperty("is_no_auto_renew") && !offer.is_no_auto_renew) {
    dataMap.set("auto_renewable", 1);
  } else {
    dataMap.set("auto_renewable", 0);
  }

  for (let key of dataMap.keys()) {
    jionUrl += `${key}=${encodeURIComponent(dataMap.get(key))}&`;
  }
  // jionUrl = encodeURI(jionUrl); //encode
  console.log("jionUrl:", {
    jionUrl,
    dataMap
  });
  return jionUrl;
};

/**
 * 生成resource
 * @param {*} offer
 */
export const resourceFactory = offer => {
  const resource = {};
  const { kind } = offer;
  const { state } = store;
  const insUserInfo = state.userInfo;
  const insMediaInfo = state.currentUserData;

  resource.full_name = insUserInfo.user.full_name;
  resource.profile_pic_url = insUserInfo.user.profile_pic_url;
  resource.username = insUserInfo.user.username;
  resource.user_id = insUserInfo.user.id;

  if (
    (kind.includes("like") ||
      kind.includes("view") ||
      kind.includes("comment")) &&
    !isSubsOffer(offer)
  ) {
    //post类型:
    resource.media_id = insMediaInfo.itemId;
    resource.media_type = insMediaInfo.mediaType;
    resource.image_thumb = insMediaInfo.imageUrl;
    resource.image_low = insMediaInfo.imageUrl;
    resource.image_high = insMediaInfo.imageUrl;
  }

  return resource;
};

/**
 * 生成缓存的postOfferData
 * @param {*} offer
 */
export const postOfferFactory = offer => {
  //通过offer生成最后的data:
  const postOfferData = {};
  const { state } = store;
  const insUserInfo = state.userInfo;
  const masterId = state.masterId;

  postOfferData.target_user_id = insUserInfo.user.id;
  postOfferData.master_id = masterId;
  postOfferData.app_version = "1.2.0";
  postOfferData.offer_id = offer.offer_id;
  postOfferData.platform = basePlatform;
  postOfferData.resource = resourceFactory(offer);
  // postOfferData.offer = offer;

  console.info("postOfferFactory:", postOfferData);
  return postOfferData;
  //transaction_id pay_platform receipt 差这几个需要原生回传
};

/**
 * paypal的生成订单 返回button_id 和 identify_id
 * @param {*} offer
 */
export const creatOrderFactory = offer => {
  //通过offer生成最后的data:
  const postOfferData = {};
  const { state } = store;
  const insUserInfo = state.userInfo;
  const masterId = state.masterId;

  const user_info = {
    user_id: insUserInfo.user.id,
    master_id: masterId,
    username: insUserInfo.user.username
  };

  postOfferData.target_user_id = insUserInfo.user.id;
  postOfferData.app_version = "1.2.0";
  postOfferData.offer_id = offer.offer_id;
  postOfferData.platform = basePlatform;
  postOfferData.offer_platform = basePlatform;
  postOfferData.primary_platform = basePlatform;
  postOfferData.feed_data = resourceFactory(offer);
  postOfferData.user_info = user_info;

  console.info("creatOrderFactory:", postOfferData);
  return postOfferData;
};



// WEBPACK FOOTER //
// ./src/utils/superpay.js